import React from "react";

import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

const AddTask: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon
      width="129"
      height="110"
      viewBox="0 0 129 110"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M56.433 109.375C48.78 109.375 41.5875 107.943 34.8555 105.079C28.1247 102.214 22.257 98.3375 17.2524 93.4489C12.2468 88.5604 8.28466 82.812 5.36597 76.2036C2.44621 69.5953 0.986328 62.5343 0.986328 55.0208C0.986328 47.5073 2.44355 40.4401 5.35799 33.8192C8.27349 27.1984 12.2298 21.4396 17.2269 16.5427C22.224 11.6448 28.1002 7.76767 34.8555 4.91142C41.6109 2.05413 48.8289 0.625488 56.5096 0.625488C62.9267 0.625488 68.9986 1.61507 74.7254 3.59424C80.4511 5.57341 85.654 8.33382 90.3342 11.8755L87.1432 15.1567C82.8885 11.9276 78.1669 9.42757 72.9783 7.65674C67.7908 5.88591 62.3013 5.00049 56.5096 5.00049C42.3629 5.00049 30.3169 9.87028 20.3716 19.6099C10.4264 29.3494 5.45372 41.1463 5.45372 55.0005C5.45372 68.8547 10.4264 80.6515 20.3716 90.3911C30.3169 100.131 42.3629 105.001 56.5096 105.001C60.3388 105.001 64.0616 104.584 67.6781 103.75C71.2946 102.917 74.7515 101.771 78.0488 100.313L81.3994 103.594C77.6765 105.469 73.7144 106.902 69.5129 107.891C65.3114 108.881 60.9515 109.375 56.433 109.375ZM105.332 100.938V82.188H86.1859V77.813H105.332V59.063H109.799V77.813H128.945V82.188H109.799V100.938H105.332ZM47.2557 78.1255L25.8761 57.188L29.0671 54.063L47.2557 71.8755L108.842 11.563L112.033 14.688L47.2557 78.1255Z"
        fill="#354052"
      />
    </SvgIcon>
  );
};

export default AddTask;
